import actionTypes from '../constants/action-types';

const activePage = (state = null, action) => {
  switch (action.type) {
    case actionTypes.SET_ACTIVE_PAGE:
      return action.payload.pageId;
    case actionTypes.CONNECT_SITE:
      return action.payload.site.meta.activePage;
    default:
      return state;
  }
};

export default activePage;
